export class RoadWorkerClient {
  constructor({ createWorker = () => new Worker(new URL('./road.worker.js', import.meta.url), { type: 'module', name: 'wanli-road-analysis' }) } = {}) {
    this.worker = createWorker();
    this.pending = new Map();
    this.sequence = 0;
    this.closed = false;
    this.worker.onmessage = ({ data }) => {
      const pending = this.pending.get(data.requestId);
      if (!pending) return;
      clearTimeout(pending.timeout);
      this.pending.delete(data.requestId);
      if (data.error) pending.reject(new Error(data.error));
      else pending.resolve(data);
    };
    this.worker.onerror = (event) => this.close(new Error(event?.message || '路珠分析线程异常'));
    this.worker.onmessageerror = () => this.close(new Error('路珠分析线程消息异常'));
  }

  analyze(record) {
    if (this.closed) return Promise.reject(new Error('路珠分析线程已关闭'));
    const requestId = ++this.sequence;
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        this.pending.delete(requestId);
        reject(new Error('路珠分析超时'));
      }, 10000);
      this.pending.set(requestId, { resolve, reject, timeout });
      // Copy before transfer: the authoritative history stays in the main
      // service so subsequent deltas can be checked without a detached buffer.
      const codes = record.codes.slice();
      try {
        this.worker.postMessage({ requestId, table: record.table, revision: record.revision, bootId: record.bootId, codes }, [codes.buffer]);
      } catch (error) {
        clearTimeout(timeout);
        this.pending.delete(requestId);
        reject(error);
      }
    });
  }

  close(error = new Error('路珠分析线程已结束')) {
    if (this.closed) return;
    this.closed = true;
    this.worker.terminate();
    for (const pending of this.pending.values()) {
      clearTimeout(pending.timeout);
      pending.reject(error);
    }
    this.pending.clear();
  }
}
